import type { Params, Pin } from 'app/common/components/Cafeteria/dataTypes/customer/settings/pin'

import type { Request } from '../../../../index'


type ApiParams = {
  customer_id: number | string,
}

export const convertParams = ({ customerID }: Params): [ApiParams, null] => {
  return [{
    customer_id: parseInt(customerID, 10),
  }, null]
}

type ResultApi = string

export const convertResult = (pin: ResultApi): Pin => {
  return pin
}

export const POST_CAFETERIA_CUSTOMER_SETTINGS_PIN: Request<Params, Pin, void> = [
  'cafeteria/customer/settings/pin',
  'post',
  ['data', 'pin'],
]
